import React, { useEffect } from 'react';
import BoneSketch from './BoneSketch';

export default function BoneBackgroundPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ 
      position: 'relative', 
      minHeight: '100vh', 
      overflow: 'hidden',
      background: '#fff'
    }}>
      <BoneSketch />
    </div>
  );
}
